var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.75 24C42.7498 28.4149 41.1917 32.6881 38.3502 36.067C35.5087 39.4459 31.566 41.7137 27.2166 42.4711C22.8671 43.2285 18.3899 42.4268 14.5736 40.2072C10.7572 37.9877 7.8464 34.4926 6.35391 30.3377C4.86142 26.1827 4.88294 21.6344 6.41469 17.4937C7.94643 13.3531 10.8902 9.88575 14.7274 7.70241C18.5646 5.51907 23.0492 4.75979 27.3912 5.55829C31.7333 6.35678 35.6543 8.66185 38.4637 12.0675C38.6519 12.2954 38.7933 12.5581 38.8799 12.8406C38.9664 13.1231 38.9965 13.4199 38.9684 13.7141C38.9403 14.0083 38.8545 14.294 38.716 14.555C38.5774 14.816 38.3888 15.0472 38.1609 15.2353C37.9331 15.4234 37.6703 15.5648 37.3878 15.6514C37.1053 15.738 36.8085 15.7681 36.5143 15.74C36.2202 15.7119 35.9344 15.6261 35.6734 15.4875C35.4124 15.349 35.1812 15.1604 34.9931 14.9325C32.9197 12.419 30.0475 10.6919 26.8552 10.0392C23.6628 9.38648 20.3432 9.8475 17.4496 11.3454C14.556 12.8434 12.2631 15.2877 10.953 18.2711C9.64299 21.2545 9.39496 24.5968 10.2503 27.7409C11.1056 30.885 13.0126 33.641 15.6534 35.5497C18.2942 37.4583 21.5094 38.4043 24.7631 38.2299C28.0168 38.0556 31.1125 36.7714 33.5342 34.5915C35.956 32.4115 37.5575 29.4675 38.0719 26.25H24C23.4033 26.25 22.831 26.0129 22.409 25.591C21.9871 25.169 21.75 24.5967 21.75 24C21.75 23.4033 21.9871 22.831 22.409 22.409C22.831 21.987 23.4033 21.75 24 21.75H40.5C41.0967 21.75 41.669 21.987 42.091 22.409C42.5129 22.831 42.75 23.4033 42.75 24Z",
    fill: "url(#paint0_linear_1559_10299)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1559_10299",
    x1: 24,
    y1: 5.24902,
    x2: 24,
    y2: 42.7491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/GoogleLogo.d47269045703ccd4ff82685d0e48b62d.svg";
export { ForwardRef as ReactComponent };